import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import sanitizeHtml from "sanitize-html";

const Start = () => {
    const [jobCode, setJobCode] = useState("");
    const [jobTitle, setJobTitle] = useState("");
    const [jobDescription, setJobDescription] = useState("");
    const [loading, setLoading] = useState(true);
    const [alreadySubmitted, setAlreadySubmitted] = useState(false);

    let { candidateId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const handleFetchFitmentQuestions = async () => {
            try {
                const response = await axios.post(
                    `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
                    }/api/v1/check-candidate-id`,
                    { candidate_id: candidateId },
          {
            withCredentials: true
          }
                );
                setLoading(false);
                setJobCode(response.data.job_code);
                setJobTitle(response.data.job_title);

                // Sanitize job description to remove inline styles and apply custom classes
                const sanitizedDescription = sanitizeHtml(response.data.job_desc, {
                    allowedTags: ["p", "a", "ul", "ol", "li", "strong", "em", "b", "i"], // Only allow these tags
                    allowedAttributes: {
                        "*": ["href", "target", "title"], // Allow only certain attributes
                    },
                    disallowedTagsMode: "discard", // Discard any disallowed tags
                    transformTags: {
                        "*": (tagName, attribs) => ({
                            tagName,
                            attribs: { ...attribs, class: "your-custom-class" }, // Add your custom class here
                        }),
                    },
                });

                setJobDescription(sanitizedDescription);
            } catch (error) {
                const message = error.response?.data?.message || "Invalid or expired assessment link";
                if (message === "You have already submitted the assessment.") {
                    setAlreadySubmitted(true)
                    setLoading(false)
                } else {
                    toast.error(message)
                    navigate("/invalid")
                }
            }
        };

        handleFetchFitmentQuestions();
    }, [candidateId]);

    const handleClick = () => {
        navigate(`/mcq/${candidateId}`);
    };

    const closeSubmittedBox = async () => {
        window.location.href = "https://powersolv.com/career"
    };

    return (
        <div>
            <div
                className={`w-screen h-screen bg-[#0A0813E3] flex items-center justify-center fixed z-[99] top-0 transition-opacity duration-200 ${!alreadySubmitted
                    ? "opacity-0 scale-95 pointer-events-none"
                    : "opacity-100 scale-100"
                    }`}
            >
                <div
                    className={`bg-white absolute rounded-[24px] shadow-md p-8 w-[311px] h-[353px] sm:h-[260px] sm:w-[360px] xl:h-[260px] xl:w-[403px] flex flex-col gap-4 items-center justify-center text-center sm:p-9 xl:p-10 sm:gap-4 xl:gap-4 transition-transform duration-400`}
                >
                    <img src="/images/error.png" className="w-[36px]" alt="" />
                    <h2 className="font-bold text-[20px] leading-[122%] tracking-[0%] text-center   sm:text-[18px] xl:text-[20px] 2xl:text-[22px] xxl:text-2xl sm:leading-none xl:leading-none text-[#5D0E23] sm:tracking-normal xl:tracking-normal">
                        You've already taken the test.
                    </h2>
                    <p className="font-medium text-[12px] leading-none tracking-[0%] text-center   sm:text-[11px] xl:text-[12px] 2xl:text-[14px] xxl:text-base sm:leading-none xl:leading-none sm:tracking-normal xl:tracking-normal text-[#636D80]">
                        Thanks for submitting
                    </p>
                    <button
                        type="button"
                        onClick={closeSubmittedBox}
                        className="mt-4 bg-[#5D0E23] hover:bg-[#55051A] font-semibold sm:text-[11px] xl:text-[12px] 2xl:text-[13px] xxl:text-[14px] leading-none tracking-[-0.04em] text-center  cursor-pointer translate-all duration-400 text-white py-3 px-9 sm:py-3 xl:py-3 2xl:py-4 xxl:py-5 sm:px-9 xl:px-10 2xl:px-11 xxl:px-12 rounded-lg"
                    >
                        Go to job portal
                    </button>
                </div>
            </div>
            {!loading ? (
                <div className=" ">
                    <div className="fixed top-0 w-full bg-white pb-4 pt-4">
                        <div className="border-b border-[#21063B1C] pb-4 px-5">
                            <img
                                src="/images/Powersolv.png"
                                alt=""
                                className="w-28 sm:w-32 xl:w-36 2xl:w-40 xxl:w-44"
                            />
                        </div>
                        <div className="text-center">
                            <h1 className="font-semibold text-[16px] sm:text-[22px] xl:text-[28px] 2xl:text-[34px] leading-[34px] tracking-[0.01em]  text-[#86203B] mt-1 sm:mt-2 xl:mt-3 2xl:mt-4">
                                Powersolv Career Opportunities
                            </h1>
                            <h1 className="font-semibold sm:text-[22px] xl:text-[28px] 2xl:text-[34px] leading-[34px] tracking-[0.01em]  mt-2 sm:mt-2 xl:mt-4 2xl:mt-5">
                                {jobTitle}
                            </h1>
                            <p className="font-semibold text-[18px] sm:text-[14px] xl:text-[16px] 2xl:text-[18px] tracking-[0.01em] text-center  mt-1 sm:mt-2 xl:mt-3">
                                Job Code : {jobCode}
                            </p>
                            <button
                                onClick={handleClick}
                                className="font-semibold text-[18px] sm:text-[14px] xl:text-[16px] 2xl:text-[18px] leading-none tracking-[0em]  text-white bg-[#7F1330] hover:bg-[#55051A] py-3 w-[200px] sm:w-[200px] xl:w-[200px] rounded-[6px] sm:mt-2 xl:mt-3 2xl:mt-4 cursor-pointer"
                            >
                                Start Assessment
                            </button>
                        </div>
                    </div>
                    <div className="text-center mt-[236px] sm:mt-[246px] xl:mt-[276px] 2xl:mt-[298px] sm:px-8 xl:px-10 px-3">

                        <div className="mt-4 sm:mt-12 xl:mt-14 2xl:mt-[62px] w-[90%] sm:w-[60%] xl:w-[55%] mx-auto text-left sm:border-b xl:border-b sm:border-[#C6C6C6] xl:border-[#C6C6C6] pb-4">
                            <h2 className="font-semibold text-[16px] sm:text-[18px] xl:text-[22px] 2xl:text-[26px] tracking-[0.01em]  text-[#8F2B45]">
                                Job Description
                            </h2>
                            <div
                                className="job-description"
                                dangerouslySetInnerHTML={{ __html: jobDescription }}
                            />
                        </div>
                        <p className=" font-semibold text-[14px] sm:text-[16px] xl:text-[18px] 2xl:text-[20px] sm:leading-[20px] xl:leading-[22px] 2xl:leading-[24px] tracking-[0.01em] text-center w-[90%] sm:w-[60%] xl:w-[55%] mx-auto text-[#7F1330] sm:mt-4 xl:mt-4">
                            You're just one step away from unlocking exciting opportunities at
                            Powersolv.! Complete our quick, job-specific assessment to
                            showcase your unique skills and connect with top recruiters.
                        </p>
                        <h2 className=" font-semibold text-[16px] leading-[34px] tracking-[0%] sm:text-[14px] xl:text-[16px] 2xl:text-[20px] xxl:text-[24px] py-2 pt-1 sm:pt-2 xl:pt-3 2xl:pt-4 xxl:pb-0">
                            Why take this assessment?
                        </h2>
                        <p className=" font-medium text-[10px] tracking-[0%] sm:text-[12px] sm:leading-[18px] xl:text-[14px] xl:leading-[20px] 2xl:text-[16px] 2xl:leading-[22px] xxl:text-[20px] text-center text-[#252527] sm:mt-1 xl:mt-1 mb-2 sm:mb-3 xl:mb-4 2xl:mb-5">
                            Get matched to the best opportunities. <br /> Fast-track your way
                            to the next round!
                        </p>
                    </div>
                </div>
            ) : (
                <ClipLoader className="absolute top-1/2 left-1/2 -translate-1/2" />
            )}
        </div>
    );
};

export default Start;
